import React, { useEffect, useState } from "react";
import { Confirm } from "semantic-ui-react";
import { PaymentCategory } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { PaymentConceptFormEdit } from "../PaymentConceptFormEdit/PaymentConceptFormEdit";
import { CustomTable, BasicModal } from "../../../Shared";

const paymentCategoryController = new PaymentCategory();

export function ListPaymentConcept(props) {
  const { paymentCategoryId, reload, onReload } = props;
  const { accessToken } = useAuth();
  const [paymentConcepts, setPaymentConcepts] = useState([]);
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedPaymentConcept, setSelectedPaymentConcept] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [titleModal, setTitleModal] = useState("");

  const onOpenCloseModal = () => {
    setShowModal(!showModal);
    onReload();
  };

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const response =
          await paymentCategoryController.getPaymentConceptsByCategoryId(
            accessToken,
            paymentCategoryId
          );
        setPaymentConcepts(response);
      } catch (error) {
        setPaymentConcepts([]);
        console.error(error);
      }
      setLoading(false);
    })();
  }, [accessToken, paymentCategoryId, reload]);

  const openUpdatePaymentConcept = (selectedPaymentConcept) => {
    setTitleModal(
      `Actualizar concepto de pago: ${selectedPaymentConcept.name}`
    );
    setSelectedPaymentConcept(selectedPaymentConcept);
    onReload();
    onOpenCloseModal();
  };

  const onOpenCloseConfirm = (selectedPaymentConcept) => {
    setSelectedPaymentConcept(selectedPaymentConcept);
    setShowConfirm(!showConfirm);
  };

  const handleConfirm = () => {
    onDelete(selectedPaymentConcept);
    setShowConfirm(false);
  };

  const onDelete = async () => {
    setLoading(true);
    try {
      await paymentCategoryController.deletePaymentConcept(
        accessToken,
        selectedPaymentConcept.id
      );
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  const tableConfig = {
    headers: ["Concepto de pago", "Monto", "Fecha de vencimiento", "Acciones"],
    fields: [
      {
        field: "name",
        dataType: "text",
        align: "center",
      },
      {
        field: "amount",
        dataType: "numeric",
        money: true,
        decimal: 2,
        align: "center",
      },
      {
        field: "dueDate",
        dataType: "date",
        format: "DD/MM/YYYY",
        align: "center",
      },
      {
        buttons: [
          {
            color: "blue",
            icon: "pencil",
            placeholder: "Actualizar concepto de pago",
            onClick: openUpdatePaymentConcept,
          },
          {
            color: "red",
            icon: "trash",
            placeholder: "Eliminar concepto de pago",
            onClick: onOpenCloseConfirm,
          },
        ],
      },
    ],
    columnWidths: ["35%", "15%", "30%", "20%"],
  };

  return (
    <>
      <div className="registered-payment__list">
        <CustomTable
          tableConfig={tableConfig}
          data={paymentConcepts}
          onReload={onReload}
          loading={loading}
        />
      </div>
      <BasicModal show={showModal} close={onOpenCloseModal} title={titleModal}>
        <PaymentConceptFormEdit
          onClose={onOpenCloseModal}
          onReload={onReload}
          paymentConcept={selectedPaymentConcept}
        />
      </BasicModal>
      <Confirm
        confirmButton="Aceptar"
        cancelButton="Cancelar"
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={handleConfirm}
        content={`¿Eliminar concepto de pago "${selectedPaymentConcept?.name}"?`}
        size="mini"
      />
    </>
  );
}
